module.exports = __webpack_public_path__ + "static/quesgasolinamovilfleet-c3f5aa4ee57f3f20d6b3c5beacbb3005.png";